import { useCallback, useMemo } from 'react';
import { useCookie } from '@/hooks/useCookie';
import { useAppSelector } from '@/store';
import { GetStartedContext } from './context';

type Props = {
  children: React.ReactNode;
};

const cookieName = 'msl-copilot:get-started-dismissed';
const dismissedCookieValue = 'dismissed';

export const GetStartedContainer = (props: Props) => {

  const getStartedEnabled = useAppSelector(s => s.group.features.workspaces);

  const [cookieValue, setCookie] = useCookie(cookieName);

  const visible = useMemo(() => {
    return cookieValue !== dismissedCookieValue && getStartedEnabled;
  }, [cookieValue, getStartedEnabled]);

  const toggleVisibility = useCallback(() => {
    setCookie({
      expires: new Date('2100-01-01'),
      value: dismissedCookieValue,
    });
  }, [setCookie]);

  return (
    <GetStartedContext.Provider value={[visible, toggleVisibility]}>
      {props.children}
    </GetStartedContext.Provider>
  );
};